import { SimulatorList } from "./simulator-list";

export class Simulator extends SimulatorList{
    public id: string;
    public organizationId: string;
    public lastEditedBy: string;
}
